<template>
  <div class="app-normal-layout-box show-flex-box-c">
    <div class="view-box">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'appLayout',
  data() {
    return {
      
    }
  },
  components: {
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
  .app-normal-layout-box {
    width: 100%;
    height: 100%;
    &>.view-box {
      width: 100%;
      height: 100%;
    }
  }
</style>
<style lang="less">
  html,body {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/appLayout.vue